import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NotificacoesAction } from 'view/extrair/Notificacao/store/Notificacoes/Notificacoes.action';
import { NotificacoesSelector } from 'view/extrair/Notificacao/store/Notificacoes/Notificacoes.selector';
import { EstadoRequisicao } from 'store/types';
import { useInicializarSse } from 'view/extrair/Notificacao/util/useInicializarSse';
import { AlertaNotificacao, AlertaNotificacaoPropsGeral } from './AlertaNotificacao';
import { ItemListaNotificacoes } from './model/ItemListaNotificacoes';
import { NotificacaoBotao } from './NotificacaoBotao';

import { NotificacaoItemPropsGeral } from './NotificacaoItem';
import { NotificacaoListaPropsGeral } from './NotificacaoLista';
import { useUpdateTitle } from './util/updateTitle';
import { useInicializarListaNotificacoes } from './util/useInicializarListaNotificacoes';


export interface NotificacaoProps extends NotificacaoItemPropsGeral, NotificacaoListaPropsGeral, AlertaNotificacaoPropsGeral {
  /**
   * Função que retorna o Token de acesso.
   * 
   * Enquanto o token retornado pela função for `undefined`, o botão de notificação ficará desabilitado.
   */
  obterTokenCorrente: () => string|undefined;

  /**
   * Quando uma notificação é recebida, deve-se atualizar o título?
   */
  isAtualizarDocumentTitle?: boolean

  /**
   * Lista de sistemas que o componente de notificação deve acompanhar
   */
  //clientIdsSistemas: string[]
}

export const Notificacao: FC<NotificacaoProps> = ({
  clientId,
  onItemClick,
  showVerTodasNotificacoes,
  showConfiguracoes,
  obterTokenCorrente = () => undefined,
  isAtualizarDocumentTitle=true, showAlertaNovaNotificacao=true, 
  // tempoAlertaEntreNovasNotificacoes=5000,
  onVerTodasNotificacoesClick
}) => {
  const dispatch = useDispatch();

  const estado = useSelector(NotificacoesSelector.lista.estado);
  const totalNaoLidas = useSelector(NotificacoesSelector.lista.totalNaoLidas);
  const notificacoes = useSelector(NotificacoesSelector.lista.notificacoes);
  const notificacaoAExibir = useSelector(NotificacoesSelector.lista.notificacaoAExibir);

  useInicializarSse(obterTokenCorrente);
  useInicializarListaNotificacoes();
  useUpdateTitle(isAtualizarDocumentTitle, totalNaoLidas);

  const itemClicado = (item: ItemListaNotificacoes) => {
    if (!item.visualizado) {
      toggleVisualizado(item);
    }

    onItemClick(item);
  }
  
  const toggleVisualizado = (item: ItemListaNotificacoes) => {
    dispatch(NotificacoesAction.lista.toggleVisualizado(item));
  }

  const exibirAlerta = showAlertaNovaNotificacao && notificacaoAExibir !== undefined;

  return <>
    <NotificacaoBotao
      totalNaoLidas={totalNaoLidas}
      disabled={false}
      loading={estado === EstadoRequisicao.CARREGANDO}

      notificacoes={notificacoes}

      onItemClick={itemClicado}
      onVisualizadoToggle={toggleVisualizado}
      
      showVerTodasNotificacoes={showVerTodasNotificacoes}
      onVerTodasNotificacoesClick={onVerTodasNotificacoesClick}
      showConfiguracoes={showConfiguracoes} />
    
    {exibirAlerta && <AlertaNotificacao 
      showAlertaNovaNotificacao={showVerTodasNotificacoes}
      // tempoAlertaEntreNovasNotificacoes={tempoAlertaEntreNovasNotificacoes}
      onAlertaClick={itemClicado}
      notificacaoAAlertar={notificacaoAExibir!!}
      clientId={clientId}
      />
    }
  </>
}
